module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.4/frontend/_next/static/images/speed-d4689cc7dfa89c721ef46bc53589c5f6.png";